import _ from 'lodash';
import dayjs from '../utils/dayjs';
import { SEARCH_TYPES } from '../utils/constants';
import { TOGGLE_SHOW_FILTER_OPTIONS_GRADEBOOK } from '../redux/constants';
import { matchesResourceTypeFilter } from '@macmillan-learning/gradebook-shared';

export function filterAssignments(assignments, options) {
  // Note: exception group filters do not affect assignments
  const search = _.get(options, 'search');
  const searchType = _.get(options, 'searchType');
  const filterTypes = _.get(options, 'filterTypes');
  let filteredAssignments = assignments;
  if (filterTypes && filterTypes.length) {
    filteredAssignments = filteredAssignments.filter((assignment) =>
      matchesResourceTypeFilter(assignment, filterTypes),
    );
  }
  if (search && searchType === SEARCH_TYPES.ASSIGNMENTS) {
    const searchTerm = search.toLocaleLowerCase();
    filteredAssignments = filteredAssignments.filter((assignment) =>
      `${assignment.name.toLowerCase()}`.includes(searchTerm),
    );
  }

  const { searchDateFrom, searchDateTo } = options;
  if (searchDateFrom && searchDateTo) {
    filteredAssignments = filteredAssignments.filter((assignment) => {
      const dueDate = assignment.assignment_due_at
        ? assignment.assignment_due_at
        : _.get(
            _.find(assignment.exceptions, {
              exception_type: 'assignment',
            }),
            'exception_value.due_date',
          );

      if (!dueDate) {
        return false;
      }

      const compareDate = dayjs(dueDate);
      return (
        compareDate.isBetween(searchDateFrom, searchDateTo) ||
        compareDate.isSame(searchDateFrom, 'day') ||
        compareDate.isSame(searchDateTo, 'day')
      );
    });
  }

  return filteredAssignments;
}

export const toggleShowFilterOptionsGradebook = () => (dispatch, getState) => {
  const { gradebook } = getState();
  const showFilterOptions = !gradebook.showFilterOptions;
  const payload = { showFilterOptions };
  dispatch({ type: TOGGLE_SHOW_FILTER_OPTIONS_GRADEBOOK, payload });
};
